import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import FieldUniDriver from '../../fields/Field/Field.uni.driver';

export default (base: UniDriver, body: UniDriver) => {
  return FieldUniDriver(base, body);
};
